import { Tag } from "@design-system/Tag/Tag";
import type { TagColor } from "./TagPlayground.lib";
import {
    Cell,
    handleClick,
    handleRemove,
    leftIcon,
} from "./TagPlaygroundMatrixShared";
import styles from "./TagPlayground.module.scss";

export const MdNormalRow = ({ color }: { color: TagColor }) => (
    <>
        <span className={styles.rowLabel}>{color}</span>
        <Cell>
            <Tag size="md" color={color}>
                Tag
            </Tag>
        </Cell>
        <Cell>
            <Tag size="md" color={color} outline>
                Tag
            </Tag>
        </Cell>
        <Cell>
            <Tag size="md" color={color} leftIcon={leftIcon}>
                Tag
            </Tag>
        </Cell>
        <Cell>
            <Tag size="md" color={color} outline leftIcon={leftIcon}>
                Tag
            </Tag>
        </Cell>
        <Cell>
            <Tag size="md" color={color} numeric>
                1
            </Tag>
        </Cell>
        <Cell>
            <Tag size="md" color={color} numeric outline>
                1
            </Tag>
        </Cell>
        <Cell>
            <Tag
                size="md"
                color={color}
                leftIcon={leftIcon}
                onRemove={handleRemove}
            >
                Filter
            </Tag>
        </Cell>
        <Cell>
            <Tag
                size="md"
                color={color}
                outline
                leftIcon={leftIcon}
                onRemove={handleRemove}
            >
                Filter
            </Tag>
        </Cell>
    </>
);

export const MdHoverRow = ({ color }: { color: TagColor }) => (
    <>
        <span className={styles.rowLabel}>{color}</span>
        <Cell>
            <Tag
                size="md"
                color={color}
                onClick={handleClick}
                data-forced-state="hover"
            >
                Tag
            </Tag>
        </Cell>
        <Cell>
            <Tag
                size="md"
                color={color}
                outline
                onClick={handleClick}
                data-forced-state="hover"
            >
                Tag
            </Tag>
        </Cell>
        <Cell>
            <Tag
                size="md"
                color={color}
                leftIcon={leftIcon}
                onClick={handleClick}
                data-forced-state="hover"
            >
                Tag
            </Tag>
        </Cell>
        <Cell>
            <Tag
                size="md"
                color={color}
                outline
                leftIcon={leftIcon}
                onClick={handleClick}
                data-forced-state="hover"
            >
                Tag
            </Tag>
        </Cell>
        <Cell>
            <Tag
                size="md"
                color={color}
                numeric
                onClick={handleClick}
                data-forced-state="hover"
            >
                1
            </Tag>
        </Cell>
        <Cell>
            <Tag
                size="md"
                color={color}
                numeric
                outline
                onClick={handleClick}
                data-forced-state="hover"
            >
                1
            </Tag>
        </Cell>
        <Cell>
            <Tag
                size="md"
                color={color}
                leftIcon={leftIcon}
                onRemove={handleRemove}
                data-forced-state="hover"
            >
                Filter
            </Tag>
        </Cell>
        <Cell>
            <Tag
                size="md"
                color={color}
                outline
                leftIcon={leftIcon}
                onRemove={handleRemove}
                data-forced-state="hover"
            >
                Filter
            </Tag>
        </Cell>
    </>
);

export const MdHoverXRow = ({ color }: { color: TagColor }) => (
    <>
        <span className={styles.rowLabel}>{color}</span>
        <Cell>
            <Tag
                size="md"
                color={color}
                leftIcon={leftIcon}
                onRemove={handleRemove}
                data-forced-state="hoverX"
            >
                Filter
            </Tag>
        </Cell>
        <Cell>
            <Tag
                size="md"
                color={color}
                outline
                leftIcon={leftIcon}
                onRemove={handleRemove}
                data-forced-state="hoverX"
            >
                Filter
            </Tag>
        </Cell>
    </>
);
